<template>
  <div class="list-wrapper" v-loading="searchState.loading">
    <NoData v-if="!searchState.list.length" />
    <GoodsList v-else :goodsList="searchState.list" />
    <InfiniteScroll
      :loading="searchState.pageLoading"
      :distance="200"
      :noMore="searchState.noMore"
      @scroll="loadMore"
    />
  </div>
</template>

<script setup>
import { watch } from "vue";
import { useRoute } from "vue-router";
import GoodsList from "@/pages/searchList/goodsList.vue";
import InfiniteScroll from "@/pages/components/InfiniteScroll/index.vue";
import { useGoodsSearch } from "@/hooks/useGoods";
import { getShopProductList } from "@/apis/goods";
import NoData from "@/components/NoData";

const $route = useRoute();

const [searchState, getSeacrhList] = useGoodsSearch({
  extraRequestFn: getShopProductList,
});

const loadMore = () => {
  const { sellerId, source } = $route.query;
  const params = {
    sellerId,
    source,
  };
  getSeacrhList(params);
};

watch(
  () => $route.query.sellerId,
  () => {
    loadMore();
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.list-wrapper {
  margin-top: 20px;
}
</style>
